
import * as ApiUrls from "./ApiUrl.Home";
import { AxiosResponse } from "axios";
// import { axiosInstance } from "../AxiosInterceptor";
import { axiosCoreInstance } from "../AxiosCoreInterceptor";
import { HomeUpdatesDto, ModuleSummaryDto } from "../../Model/Dto/Home/Home";

export const HomeService = {
    getModuleSummary: (): Promise<AxiosResponse<ModuleSummaryDto.Response>> => axiosCoreInstance.get(ApiUrls.GetSummary),
    getHomeUpdates:():Promise<AxiosResponse<HomeUpdatesDto.Response[]>> => axiosCoreInstance.get(ApiUrls.GetUpdates),
}